import { render } from "./IndexProduit.vue?vue&type=template&id=3fc5e9a0"
import script from "./IndexProduit.vue?vue&type=script&lang=js"
export * from "./IndexProduit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__